import { APP_CONFIG } from '@careconne/core/configs';

export const API_BASE_URL = APP_CONFIG.apiBaseUrl;
export const TOKEN_URL = APP_CONFIG.tokenApiUrl;

export const API_ENDPOINT = {
  token: {
    refreshToken: TOKEN_URL + 'ck-pass/token/refresh',
    logout: TOKEN_URL + 'token/logout',
  },
  auth: {
    getUserByToken: API_BASE_URL + 'auth/get-user-by-token',
    base: TOKEN_URL + '/user',
    loginByCKPass: TOKEN_URL + 'user/login',
    verifyRefreshToken: TOKEN_URL + 'ck-pass/token/verify-refresh-token',
  },
  saucerLog: {
    getLog: APP_CONFIG.apiBaseUrl + 'logs',
    bulkLog: APP_CONFIG.apiBaseUrl + 'logs/bulk',
  },
  redirect: {
    app: API_BASE_URL + 'redirect/app',
  },
  recordList: {
    base: API_BASE_URL + 'record-list',
    getDataRecord: '/get-data-record',
    getFileSourceApi: '/get-file-source-api',
  },
  answer: {
    base: API_BASE_URL,
    getData: 'note/get-answer',
    saveData: 'note/save-note',
    checkDelExistAnswer: 'note/check-del-exists-answer',
    getDataRecord: '/get-data-record',
    updateConfirm: 'talk/confirm-adj-schedule',
    updateSchedAdjTarget: 'note/update-sched-adj-target',
  },
  CARECONNE_COMPANY: {
    CONTROLLER: API_BASE_URL + 'careconne-company',
    GET_INFOSENT_OFFICES: 'infosent-offices',
    GET_PLAN_SIGN_AGREE_LIST: 'plan-sign-agree-list',
    DELETE_PLAN: 'delete-plan',
    GET_INFOSENT_OFFICE_DAI: 'get-infosent-office-dai',
  },
};
